import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatInput } from "@angular/material/input";
import { FormControl, FormGroup } from "@angular/forms";
import { RecordAction } from "../../../../../../../../../utils/enums/shared/enums";
import { ContactRule } from "../../../../../../../../../utils/types/admon/contact-rule.type";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-contact-rule-form",
    templateUrl: "./contact-rule-form.component.html",
    styleUrls: ["./contact-rule-form.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [],
})
export class ContactRuleFormComponent implements OnInit {
    contactRule: ContactRule = new ContactRule();
    dialogTitle: string;
    contactRuleForm: FormGroup;
    action: RecordAction;
    callback: (contactRule) => void;
    recordAction = RecordAction;
    form: FormGroup;
    actionInput: any;
    periods: any = [];
    contactDaysId: Array<any> = [];
    itemsEdit: Array<any> = [];

    messagePeriods = [
        { name: "Diaria (2 mensajes)", value: "Diaria (2 mensajes)" },
        { name: "Semanal (10 mensajes)", value: "Semanal (10 mensajes)" },
        { name: "Mensual (60 mensajes)", value: "Mensual (60 mensajes)" },
    ];

    contactTimes = [
        { name: "08:00 a 18:00", value: "08:00 a 18:00" },
        { name: "08:00 a 19:00", value: "08:00 a 19:00" },
        { name: "08:00 a 20:00", value: "08:00 a 20:00" },
    ];

    dates = [
        { value: 1, display: "Lunes" },
        { value: 2, display: "Martes" },
        { value: 3, display: "Miércoles" },
        { value: 4, display: "Jueves" },
        { value: 5, display: "Viernes" },
        { value: 6, display: "Sábado" },
        { value: 7, display: "Domingo" },
    ];
    constructor(
        public dialogRef: MatDialogRef<ContactRuleFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private translateService: TranslateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.action = data.action;
        this.callback = data.callback;
        this.periods = data.periods;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.contactRule = data.contactRule;
            this.dialogTitle = this.contactRule.name;

            const cast = data.contactRule.contact_period.toString().split("");

            for (let i = 0, n = cast.length; i < n; i++) {
                if (cast[i] === "1") {
                    const item = i + 1;
                    for (const day of this.dates) {
                        if (item === day.value) {
                            this.itemsEdit.push({
                                name: day.display,
                                roleId: day.value,
                            });
                            this.itemsEdit.forEach((item) => {
                                item.name = this.translateService.instant(
                                    item.name
                                );
                            });
                            this.contactDaysId.push({
                                display: day.display,
                                id: day.value,
                            });
                        }
                    }
                }
            }
        }

        this.dialogTitle = "Regla de Contactabilidad";
        this.dialogTitle = this.translateService.instant(this.dialogTitle);
        this.contactRuleForm = this.createForm();

        this.periods.forEach((element) => {
            element.name = this.translateService.instant(element.name);
        });

        this.dates.forEach((element) => {
            element.display = this.translateService.instant(element.display);
        });
    }

    addItem(day) {
        if (this.contactDaysId.length === 0) {
            this.contactDaysId.push({ display: day.display, id: day.value });
            return;
        }

        for (const contact of this.contactDaysId) {
            if (contact.id === day.value) {
                return;
            }
        }

        this.contactDaysId.push({ display: day.display, id: day.value });
    }

    deleteItem(day) {
        let index: number;

        let i = 0;
        for (const contact of this.contactDaysId) {
            if (contact.id === day.value) {
                index = i;
            }
            i++;
        }

        if (i > 0) {
            this.contactDaysId.splice(index, 1);
        }
    }

    ngOnInit() {
        this.actionInput = this.action;
    }

    onCommentChange() {
        alert("Entro cambio");
    }
    createForm() {
        this.form = new FormGroup({
            name: new FormControl(this.contactRule.name),
            periodCatalogId: new FormControl(this.contactRule.periodCatalogId),
            contact_period: new FormControl(this.contactRule.contact_period),
            message_quantity: new FormControl(
                this.contactRule.message_quantity
            ),
            hour_period_init: new FormControl(
                this.contactRule.hour_period_init
            ),
            hour_period_end: new FormControl(this.contactRule.hour_period_end),
        });

        const form = this.form;

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.contactRule.name = value)
        );
        form.controls["periodCatalogId"].valueChanges.subscribe(
            (value) => (this.contactRule.periodCatalogId = value)
        );
        form.controls["contact_period"].valueChanges.subscribe(
            (value) => (this.contactRule.contact_period = value)
        );
        form.controls["message_quantity"].valueChanges.subscribe(
            (value) => (this.contactRule.message_quantity = value)
        );

        form.controls["hour_period_init"].valueChanges.subscribe(
            (value) => (this.contactRule.hour_period_init = value)
        );

        form.controls["hour_period_end"].valueChanges.subscribe(
            (value) => (this.contactRule.hour_period_end = value)
        );

        form.controls["periodCatalogId"].setValue(
            this.contactRule.periodCatalogId
        );

        return form;
    }

    saveRule() {
        if (this.contactRuleForm.invalid) {
            return;
        }

        let value = "";

        for (const day of this.dates) {
            const found = this.contactDaysId.find((contactDay) => {
                return contactDay.id === day.value;
            });

            value += found ? "1" : "0";
        }

        this.contactRule.contact_period = value;
        this.callback(this.contactRule);
    }
}
